import React from "react";

const BsCol = (props) => <div className={props.class}>{props.children}</div>;

export default BsCol;
